<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/require-v-for-key -->
<template lang="">
        
    <MessageEvent v-if='messagesStore.active'/>
 
    <AddEntryForm  v-if='componentsStore.showAddEntry.show' @refresh-event="getData"  />

    
    
    
    <div class="font-bold mb-5 text-lg"> Dashboard </div>
    <div v-if="userInfo.listMonths && unitSystems.getUnits(userInfo.userInfo.weightSystem)"  class='top flex  bg-site-primary rounded p-6  '>
        <div  class="flex flex-col  basis-1/4 ">
            <div class="text-lg font-bold">  {{userInfo.currentWeight}} {{unitSystems.getUnits(userInfo.userInfo.weightSystem).weight}}</div>
            <div class="text-sm"> Current Weight</div>

        </div>
        <div  class="flex flex-col basis-1/4 ">
            <div class="text-lg font-bold text-red-400" v-if='userInfo.weightChange > 0.01' > {{utils.changeOperatorsAndRound(userInfo.weightChange)}} {{unitSystems.getUnits(userInfo.userInfo.weightSystem).weight}}</div>
          <div class="text-lg font-bold text-green-400" v-else>{{utils.changeOperatorsAndRound(userInfo.weightChange)}} kg</div>


            <div class="text-sm">Total Change</div>

         </div>
         <div  class="flex flex-col basis-1/4 ">
            <div class="text-lg font-bold"> {{utils.getPercentProgress(userInfo.userInfo.currentWeight, userInfo.currentWeight, userInfo.userInfo.weightGoal)}} </div>
            <div class="text-sm"> Progress</div>

         </div>

         <div  class="flex flex-col basis-1/4 ">
            <div class="text-lg font-bold"> {{utils.calculateBodyMassIndex( userInfo.currentWeight, userInfo.userInfo.currentHeight, 1)}} </div>
            <div class="text-sm"> BMI</div>

         </div>
        <div  class="flex flex-col basis-1/4 ">
            <div class="text-lg font-bold">{{(userInfo.currentWeight - userInfo.userInfo.weightGoal).toFixed(2)}} {{unitSystems.getUnits(userInfo.userInfo.weightSystem).weight}}</div>
            <div class="text-sm"> Remaining Weight</div>

         </div>
        
         
    </div>



    <div v-else> ...Loading </div>
    <div v-if="(userInfo.listMonths && userInfo.cleanEntries) && (Object.keys(userInfo.cleanEntries ).length > 0 || Object.keys(userInfo.listMonths).length > 0)"   class='flex flex-col lg:flex-row'>

        <MonthHeatMapChart  class='w-full lg:w-1/3'/>
        <WeightChangeChart class='w-full lg:w-1/3'/>
        <WeightChangeMonthsChart  class='w-full lg:w-1/3' />


         </div>
  

    <div class="flex flex-col mt-4 ">
    <FormKit
        v-if="(userInfo.yearsToPick).length > 1"
        v-model='pickedYearForm'
        type="select"
        :placeholder="userInfo.pickedYear"
        name="year"
        @change="changeYear(pickedYearForm)"
        :options="userInfo.yearsToPick"
        > Year</FormKit>
   

    </div>
    
    <div class='flex flex-col lg:flex-row justify-between '>
        <div class='flex flex-col w-full gap-2 '>
            <div v-for="(month, monthIndex) in userInfo.listMonths" class='' :key="monthIndex">
      
      <AListMonths @refresh-event="getData" :month="monthNames[monthIndex -1]" :monthNumber = "monthIndex" :weeks="month.month[0]" :year = "userInfo.pickedYear" :weightDifference = "month.weightStart - month.weightEnd" :userUnits = unitSystems.getUnits(userInfo.userInfo.weightSystem)> </AListMonths>

        </div>
             </div> 
      
        <!-- <div class=' w-full lg:w-1/2 '>

        </div> -->
    </div> 


   
</template>
<script setup>
import { onMounted, defineModel} from 'vue';
import {UserInfo} from '@/stores/UserInfo'
// import {getWeeksInMonth} from '@/utils/utils'
import {utils} from '@/utils/utils'
import AListMonths from '@/components/Dashboard/ListObjects/AListMonths.vue'
// eslint-disable-next-line no-unused-vars
import AddEntryForm from '../AddEntryForm.vue';
// eslint-disable-next-line no-unused-vars

import { getUserInfo } from '@/services/UserService';
import { UnitSystems } from '@/stores/UnitsSystems';
import MessageEvent from '../MessageEvent.vue';
import { MessageStore } from '@/stores/Messages';
import {ComponentsStore} from '@/stores/ComponentsStore';
import WeightChangeChart from '@/components/Charts/WeightChangeChart.vue'
import WeightChangeMonthsChart from '../Charts/WeightChangeMonthsChart.vue';
import MonthHeatMapChart from '../Charts/MonthHeatMapChart.vue';



// eslint-disable-next-line no-unused-vars
const messagesStore = MessageStore();

const componentsStore = ComponentsStore();
const userInfo = UserInfo();
// eslint-disable-next-line no-unused-vars
const unitSystems = UnitSystems();

const pickedYearForm = defineModel()

let currentDate = new Date();
let currentYear = currentDate.getFullYear();


// eslint-disable-next-line no-unused-vars


let allWeeks = [];


async function changeYear(pickedYear){
    userInfo.setYear(pickedYear)
    await getData();
}

async function getData(){

    allWeeks = await utils.getAllWeeks(userInfo.pickedYear);

   let entries = await utils.sortedYearWeightEntries();

    if (entries[userInfo.pickedYear] != null) {

        await utils.fillDatesEntries(entries[userInfo.pickedYear], allWeeks);
        userInfo.setCurrentWeight(entries[currentYear]);

        userInfo.setListMonths(allWeeks);

        let yearsSelect = await getYearsForm(entries);

   

        userInfo.setYearsToPick(yearsSelect);

        let cleanEntries = await utils.getCleanTableOfEntries();
        
        userInfo.setCleanEntries(cleanEntries);
        
      
    }
    else{
        userInfo.setYear(currentYear)
        alert('No entries for this year.')
        componentsStore.changeAddEntryForm();
    }


}



const monthNames = [
        "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
]

function getYearsForm(entries){
    let tempArray = [];

    let entriesYearsKeys = Object.keys(entries);
    entriesYearsKeys.forEach(year => {
        tempArray.push(year)
    });
    tempArray.sort();


    return tempArray;

   
}

onMounted(async () => {
   
    // eslint-disable-next-line no-unused-vars



   try {
   // eslint-disable-next-line no-unused-vars


   if(!userInfo.pickedYear){
    userInfo.setYear(currentYear)
    }

    if(userInfo.listMonths.length < 1){
        let _userInfo = await getUserInfo();
        
        userInfo.setUserInfo(_userInfo.data);
        getData();



  
        
    }
   
  

    

   
  



//    console.log(entries)
} 
catch (error) {
   console.error(error);
 }
      
     


});



</script>
<style lang="css">

.formkit-outer {
  margin: 0px !important;

}

.formkit-input{
  font-size: 1.5vh;
}
</style>